module.exports = __webpack_public_path__ + "img/tab04.b781dd74.png";